import Lenis from 'lenis';

let lenis;

const init = async () => {
lenis = new Lenis({
       duration: 1.2,
       easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // optional
       smooth: true,
       direction: 'vertical',
       gestureDirection: 'vertical',
       smoothTouch: false,
});
     
function raf(time) {
       lenis.raf(time);
       requestAnimationFrame(raf);
}
     
requestAnimationFrame(raf);

lenis.on('scroll', (e) => {        
       scrollUpdates(e);
})

// Smooth scroll for # links, but skip special ones like #login
document.addEventListener('click', (e) => {
  const link = e.target.closest('a[href^="#"]');
  if (!link) return;

  const targetId = link.getAttribute('href');

  // skip if hash is used for modal or JS triggers
  const skipHashes = ['#login', '#register', '#cart']; // add more if needed
  if (skipHashes.includes(targetId)) return;

  if (targetId && targetId.length > 1) {
    const targetEl = document.querySelector(targetId);
    if (targetEl) {
      e.preventDefault();
      lenis.scrollTo(targetEl, { offset: -20 });
    }
  }
});



let body = document.querySelector('body');
var lastDir = 'down';
function scrollUpdates(e) {
       var progressTop = e.actualScroll;
       var direction = e.direction;    
   
     if (progressTop > 250) {
       if (!body.classList.contains("short-header")) {
         body.classList.add("short-header");
       }
     } else {
       if (body.classList.contains("short-header")) {
         body.classList.remove("short-header");
       }
     }
   
     if (lastDir === 'up') {
       if (!body.classList.contains("scrollingtop")) {
         body.classList.add("scrollingtop");
       }
     } else {
       if (body.classList.contains("scrollingtop")) {
         body.classList.remove("scrollingtop");
       }
     }
     if (direction === -1) {
       lastDir = 'up';
     } 
     if (direction === 1) {
       lastDir = 'down';
     }
}

    // Scroll to hash on load
    if (window.location.hash) {
      const hash = window.location.hash;
      const targetEl = document.querySelector(hash);
      if (targetEl) {
        // Wait a bit for other elements to settle
        setTimeout(() => {
          lenis.scrollTo(targetEl, { offset: -20 });
        }, 500);
      }
    }
}

export { init, lenis };